import React from "react";
import { useState } from "react";
import {
  Container,
  Form,
  InputGroup,
  Button,
  Card,
  Modal,
} from "react-bootstrap";

const Signin = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setShow(true);
  };

  return (
    <>
      <Container className="signin-page py-5 mb-5">
        <Card className="signin-card mt-5" id="signin">
          <Card.Body className="signin-card-body">
            <div className="signin-header text-center mb-4">
              <h2 className="mb-2">Sign In</h2>
              <p className="mb-0">Use your official Ecorvi account to continue.</p>
            </div>

            <Form className="signin-form" id="singin-form" onSubmit={handleSubmit}>
              <Form.Group className="formgroup mb-4" controlId="signinEmail">
                <Form.Label>E-Mail</Form.Label>
                <InputGroup className="w-100">
                  <InputGroup.Text id="email">
                    <i className="fa fa-envelope pt-0"></i>
                  </InputGroup.Text>
                  <Form.Control
                    type="email"
                    required
                    placeholder="Enter E-mail Address"
                    pattern=".+@ecorvi.com"
                  ></Form.Control>
                </InputGroup>
                <small id="emailHelpId" className="form-text text-muted mb-3">
                  Must end with `@ecorvi.com`
                </small>
              </Form.Group>

              <Form.Group className="mb-4" controlId="signinPassword">
                <Form.Label>Password</Form.Label>
                <InputGroup>
                  <InputGroup.Text id="password">
                    <i className="fa fa-key pt-0"></i>
                  </InputGroup.Text>
                  <Form.Control
                    type="password"
                    required
                    placeholder="Enter Password"
                  ></Form.Control>
                </InputGroup>
              </Form.Group>
              <Button className="signin-btn w-100" size="md" type="submit">
                Sign In
              </Button>
            </Form>
          </Card.Body>
        </Card>

        <Modal show={show} onHide={handleClose} animation={false} centered>
          <Modal.Header closeButton>
            <Modal.Title>Login Error</Modal.Title>
          </Modal.Header>
          <Modal.Body>Invalid Email / Password!</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
};

export default Signin;
